import type { ChangeEvent } from 'react';

import { fieldStyle } from '../venueCreateFields';

interface SelectProps {
  value: string;
  onChange: (v: string) => void;
  options: readonly string[];
}

/** Controlled single-choice input for the venue detail-page edit sections. */
export function Select({ value, onChange, options }: SelectProps) {
  return (
    <select
      value={value}
      onChange={(e: ChangeEvent<HTMLSelectElement>) => onChange(e.target.value)}
      style={fieldStyle(undefined)}
    >
      {options.map((o) => (
        <option key={o}>{o}</option>
      ))}
    </select>
  );
}
